﻿import { useResolvedPreferences } from './useResolvedPreferences';
import { Language } from '@lingvo-news/contracts';

export function useLocalFonts() {
	let preferences = useResolvedPreferences();
	const updateFont = () => {
		preferences.update();
		const lang = preferences.nativeLanguage.value;
		setLocaleFont(lang || Language.EN);
	}

	const setLocaleFont = (lang?: Language) => {
		Object.keys(Language).forEach((key) => {
			document.body.classList.remove(key)
			document.body.classList.remove(key.toLowerCase())
		});
		document.body.classList.add(lang || Language.EN);
	}

	return {
		setLocaleFont,
		updateFont,
	}
}
